import {
    instance
} from '../../util/http'
import apis from '../../config/apis'

// 获取服务人二维码
const get = () => {
    return instance.get(apis.Superior.Get)
}
// 获取我的二维码名片
const getBusinessCard = () => {
    return instance.get(apis.Superior.GetBusinessCard)
}
// 上传我的二维码名片
const upload = (postData) => {
    return instance.post(apis.Superior.Upload, postData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
export default {
    get,
    getBusinessCard,
    upload
}